module.exports = __webpack_public_path__ + "static/media/SC_LT_08.8bd39077.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/pants/SC_LT_08.png
// module id = 93
// module chunks = 0